var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "contact-us-form-container px-2 h-max-100 overflow-y-auto py-3 w-100",
      style: _vm.containerStyle,
    },
    [
      _vm.isStatusDone
        ? [
            _c("div", { staticClass: "w-100 mb-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "font-weight-bold font-size-200 text-center mb-5",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("trans")("How can we help?")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.education
                ? _c("div", { staticClass: "text-center mx-auto mb-4" }, [
                    _c(
                      "span",
                      { staticClass: "font-size-125 font-weight-bold" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "We could not automatically verify by your email address that you are a teacher or student. Please contact us to get your free educational account."
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mx-auto p-0 mb-4" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionType,
                        expression: "questionType",
                      },
                    ],
                    staticClass: "w-100 p-2 br-4 border",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.questionType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "question" } }, [
                      _vm._v(_vm._s(_vm._f("trans")("Ask a question"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "issue" } }, [
                      _vm._v(_vm._s(_vm._f("trans")("Report an issue"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "feature" } }, [
                      _vm._v(_vm._s(_vm._f("trans")("Suggest a feature"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "sales" } }, [
                      _vm._v(_vm._s(_vm._f("trans")("Contact sales"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "accounting" } }, [
                      _vm._v(_vm._s(_vm._f("trans")("Contact accounting"))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-auto p-0 mb-4" },
                [
                  _c("TextArea", {
                    attrs: {
                      name: "form",
                      type: "text",
                      label: _vm.getPlaceholder,
                      "max-characters": 4000,
                    },
                    model: {
                      value: _vm.inputForm,
                      callback: function ($$v) {
                        _vm.inputForm = $$v
                      },
                      expression: "inputForm",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-auto p-0 mb-4" },
                [
                  _c("TextInput", {
                    attrs: {
                      name: "email",
                      type: "email",
                      autocomplete: "on",
                      "trim-input": true,
                      label: _vm._f("trans")("E-Mail"),
                      icon: "far fa-envelope",
                      "has-error": _vm.invalidEmail,
                      "current-error": _vm.getInvalidEmailError,
                    },
                    model: {
                      value: _vm.inputEmail,
                      callback: function ($$v) {
                        _vm.inputEmail = $$v
                      },
                      expression: "inputEmail",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isUser !== true
                ? _c("div", { staticClass: "mx-auto mb-4 card p-4 mb-5" }, [
                    _c("label", { staticClass: "px-0 mb-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.acceptTos,
                            expression: "acceptTos",
                          },
                        ],
                        staticClass: "m-2",
                        attrs: { type: "checkbox", id: "acceptTos" },
                        domProps: {
                          checked: Array.isArray(_vm.acceptTos)
                            ? _vm._i(_vm.acceptTos, null) > -1
                            : _vm.acceptTos,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.acceptTos,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.acceptTos = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.acceptTos = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.acceptTos = $$c
                            }
                          },
                        },
                      }),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.getTosText) },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mx-auto p-0 mb-4 text-center" }, [
                _vm.ticketCreated !== true
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-success",
                        class: {
                          "col-5": _vm.buttonBlock === false,
                          "btn-block": _vm.buttonBlock === true,
                        },
                        attrs: { id: "formSend", disabled: !_vm.canSubmit },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.submitForm.apply(null, arguments)
                          },
                          "ticket-created": _vm.onTicketCreated,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("trans")("Send")) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-100 text-center" }, [
              _vm.ticketCreated === "failed"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "w-fit-content m-auto p-2 badge badge-danger text-center font-size-100",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Something went wrong. Please try again later."
                          )
                        ) + "\n            "
                      ),
                    ]
                  )
                : _vm.ticketCreated === true
                ? _c(
                    "span",
                    {
                      staticClass:
                        "w-fit-content m-auto p-2 badge badge-success text-center font-size-100",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Thank you! We have recieved your request and will get back to you soon."
                          )
                        ) + "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ticketCreated === true
                ? _c("div", { staticClass: "w-100" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "small w-fit-content btn btn-info mt-2 p-1",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.prepareNewRequest.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("trans")("Send another request")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showBackButton
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.onBackButtonClick.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm._f("trans")("Back")))]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        : _vm.isStatusLoading
        ? _c("LoadingAnimation", { attrs: { "animation-style": "bars" } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }